module.exports = __webpack_public_path__ + "img/Professional-6.911b5086.gif";